import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    fullWidthContainer: { display: 'flex', flexWrap: 'wrap', width: '100%' },
    containerpadding: { padding: '0px 20px 20px' },
  };
});
